if (!customElements.get('my-collapse')) {
  customElements.define(
    'my-collapse',
    class MyCollapse extends HTMLElement {
      constructor() {
        super();
        this.enableMore = this.dataset.enableMore === 'true';
      }

      enableMore = false;

      connectedCallback() {
        this.initExpand();
        this.initCollapse();
      }

      disconnectedCallback() {}

      initExpand() {
        this.querySelector('.icon-group')?.addEventListener('click', () => {
          this.querySelector('.collapse-wrapper').classList.toggle('isExpand');
        });
      }

      initCollapse() {
        this.collapseHeader = this.querySelectorAll('.collapse-title');
        this.collapseHeader.forEach((item) => {
          item.addEventListener('click', () => {
            this.toggleCollapse(item);
          });
        });

        this.collapseBody = this.querySelectorAll('.collapse-body');
        this.collapseBody.forEach((item) => {
          // 获取content高度
          const contentHeight = item.querySelector('.collapse-body-content').offsetHeight;
          console.log(contentHeight);
          // 设置body css变量
          item.style.setProperty('--content-height', `${contentHeight}px`);
        });
      }

      toggleCollapse(item) {
        item.parentElement.classList.toggle('isExpand');
      }
    }
  );
}
